import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const createMemory = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/memory/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateMemory = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/memory/update/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllMemory = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/memory/getAllMemory`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getMemoryByID = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/memory/getMemoryById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteMemory = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/memory/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
